import { Permission } from './permission';

export class Role {
    roleId: string;
    roleName: string;
    admin: boolean;
    valid: boolean;
    rolePermission:Permission[] = [];
}